/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleADownIcon20Light = forwardRef('ArrowShapeTriangleADownIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.879 6a1.1 1.1 0 0 1 .915 1.71l-4.879 7.318a1.1 1.1 0 0 1-1.83 0L4.205 7.71A1.1 1.1 0 0 1 5.122 6h9.758Zm.083 1.155A.1.1 0 0 0 14.879 7H5.12a.1.1 0 0 0-.083.155l4.879 7.319a.1.1 0 0 0 .166 0l4.879-7.319Z" })));
});
